import { lazy } from "react";
import { BiSliderAlt } from "react-icons/bi";
import { FaBuilding, FaCar, FaChargingStation, FaFileAlt, FaMoneyBillAlt, FaPhone, FaTh } from "react-icons/fa";
import { HiUsers } from "react-icons/hi";

export const menuItems = [
  {
    name: "",
    item: [
      {
        id: "dashboard",
        name: "dashboard",
        path: "/dashboard",
        icon: <FaTh />,
      },
      {
        id: "sales-order",
        name: "sale_order",
        path: "/sale-order",
        icon: <FaFileAlt />,
      },
      {
        id: "sale_order_payback",
        name: "sale_order_payback",
        path: "/sale-order-payback",
        icon: <FaFileAlt />,
      },
    ],
  },
  {
    name: "report",
    item: [
      {
        id: "report-sales-order",
        name: "sale_order",
        path: "/report-sale-order",
        icon: <FaFileAlt />,
      },
    ],
  },
  {
    name: "setting",
    item: [
      {
        id: "driver",
        name: "customer_app",
        path: "/customer-app",
        icon: <FaPhone />,
      },
      {
        id: "users",
        name: "company",
        path: "/company",
        icon: <FaBuilding />,
      },
      {
        id: "driver",
        name: "driver",
        path: "/driver",
        icon: <FaCar />,
      },
      {
        id: "station",
        name: "station",
        path: "/station",
        icon: <FaBuilding />,
      },
      {
        id: "charger-account",
        name: "charger_account",
        path: "/charger-account",
        icon: <FaChargingStation />,
      },
      {
        id: "charger-price",
        name: "charger_price",
        path: "/charger-price",
        icon: <FaMoneyBillAlt />,
      },
      {
        id: "system-roles",
        name: "system_role",
        path: "/system-role",
        icon: <BiSliderAlt />,
      },
      {
        id: "users",
        name: "user",
        path: "/user",
        icon: <HiUsers />,
      },
    ],
  },
];

export const menuItemsCustomerApp = [
  {
    id: "kwh-setting",
    name: "faq_setting",
    path: "faq-setting",
    component: lazy(() => import("../../view/app/setting/customer-app/faq-setting")),
  },
  {
    id: "price-setting",
    name: "contact_us_setting",
    path: "contact-us-setting",
    component: lazy(() => import("../../view/app/setting/customer-app/contact-us-setting")),
  },
  {
    id: "label-setting",
    name: "privacy_term_setting",
    path: "privacy-term-setting",
    component: lazy(() => import("../../view/app/setting/customer-app/privacy-term-setting")),
  },
  {
    id: "video-setting",
    name: "slide_show_setting",
    path: "slide-show-setting",
    component: lazy(() => import("../../view/app/setting/customer-app/slide-show-setting")),
  },
  {
    id: "video-setting",
    name: "new_feed_setting",
    path: "new-feed-setting",
    component: lazy(() => import("../../view/app/setting/customer-app/new-feed-setting")),
  },
];

export const menuItemsChargerPrice = [
  {
    id: "kwh-setting",
    name: "kwh_display_setting",
    component: lazy(() => import("../../view/app/setting/charger-price/kwh-display-setting")),
  },
  {
    id: "price-setting",
    name: "price_display_setting",
    component: lazy(() => import("../../view/app/setting/charger-price/price-display-setting")),
  },
  {
    id: "label-setting",
    name: "label_display_setting",
    component: lazy(() => import("../../view/app/setting/charger-price/label-display-setting")),
  },
  {
    id: "video-setting",
    name: "video_setting",
    component: lazy(() => import("../../view/app/setting/charger-price/video-setting")),
  },
];
